import { render, staticRenderFns } from "./AdCreateLog.vue?vue&type=template&id=71673b13&scoped=true&"
import script from "./AdCreateLog.vue?vue&type=script&lang=js&"
export * from "./AdCreateLog.vue?vue&type=script&lang=js&"
import style0 from "./AdCreateLog.vue?vue&type=style&index=0&id=71673b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71673b13",
  null
  
)

export default component.exports